// @flow

import React from 'react';
import styled from 'styled-components';

import {CanvasManager} from './managers/canvas-manager';
import {throttle} from './utils';

export const StyledCanvasContainerDiv = styled.div`
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16),
    0 -1px 3px rgba(0, 0, 0, 0.12), 0 -1px 1px 1px rgba(0, 0, 0, 0.16);
  background: #fff;
  border-radius: 3px;
`;

type Props = {
  onReady: (CanvasManager) => any,
};

export class BieCanvas extends React.Component<Props> {
  canvasRef = React.createRef();
  throttledResize: () => any;

  componentDidMount() {
    if (this.canvasRef.current != null) {
      const canvasManager = new CanvasManager(this.canvasRef.current);
      this.throttledResize = throttle(canvasManager.updateCanvasSize, 500);
      window.addEventListener('resize', this.throttledResize);
      this.props.onReady(canvasManager);
    }
  }

  render() {
    return (
      <StyledCanvasContainerDiv>
        <canvas ref={this.canvasRef} />
      </StyledCanvasContainerDiv>
    );
  }

  componentWillUnmount() {
    if (this.throttledResize != null) {
      window.removeEventListener('resize', this.throttledResize);
    }
  }
}
